import React from "react";
import "styles/public.css";

const MiniTitle = ({ children }) => {
  return (
    <p className="mini_title_header">
      <span>//</span> {children}
    </p>
  );
};

export default MiniTitle;
